import { useEffect, useState } from "react";
import api from "../lib/api";
import Sidebar from "../components/Sidebar";
import { useTranslation } from "react-i18next";
import { Bell, Check } from "lucide-react";
import { i18nLocale } from "../lib/locale";

export default function Alerts() {
  const { t } = useTranslation();
  const [alerts, setAlerts] = useState([]);
  const load = async () => {
    const { data } = await api.get("/alerts");
    setAlerts(data);
  };
  useEffect(() => { load(); }, []);

  const markRead = async (id) => {
    await api.post(`/alerts/${id}/read`);
    load();
  };

  return (
    <div className="flex bg-[#F7F8F6] min-h-screen">
      <Sidebar />
      <main className="flex-1 min-w-0">
        <div className="max-w-4xl mx-auto p-6 lg:p-10">
          <h1 className="text-3xl sm:text-4xl font-medium tracking-tight mb-2" style={{ fontFamily: "Outfit" }}>{t("alerts.title")}</h1>
          <p className="text-sm text-[#6B726A] mb-8">{t("alerts.subtitle")}</p>

          {alerts.length === 0 ? (
            <div className="rp-card p-12 text-center text-sm text-[#6B726A]">{t("alerts.empty")}</div>
          ) : (
            <ul className="space-y-3">
              {alerts.map((a) => (
                <li key={a.id} className={`rp-card p-5 flex items-start gap-4 ${a.read ? "opacity-60" : ""}`} data-testid={`alert-${a.id}`}>
                  <div className="w-10 h-10 rounded-xl bg-[#E8F0EA] grid place-items-center shrink-0">
                    <Bell className="w-4 h-4 text-[#1A4D2E]" />
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="font-medium text-sm">{a.title}</div>
                    <div className="text-sm text-[#6B726A]">{a.message}</div>
                    <div className="text-xs text-[#6B726A] mt-1">{new Date(a.created_at).toLocaleString(i18nLocale())}</div>
                  </div>
                  {!a.read && (
                    <button onClick={() => markRead(a.id)} data-testid={`mark-read-${a.id}`} className="text-[#1A4D2E] p-2 hover:bg-[#E8F0EA] rounded-lg">
                      <Check className="w-4 h-4" />
                    </button>
                  )}
                </li>
              ))}
            </ul>
          )}
        </div>
      </main>
    </div>
  );
}
